export const SELLER_PRODUCT_LOADING_PERIOD = 600000
export const CATEGORY_PRODUCT_LOADING_PERIOD = 600000
export const FEATURED_PRODUCT_LOADING_PERIOD = 600000
export const DEFAULT_LOADING_PERIOD = 600000 //10 mins
export const COUNTRY_SETTLEMENT_LOADING_PERIOD = 12 * 60 * 60 * 1000 //every 12 hrs
export const FEATURED_PRODUCTS_LOADING_ID = "isFeatured"
export const NEWEST_PRODUCTS_LOADING_ID = "newestProducts"